import React, { useState } from 'react'
import { useAppDispatch } from '../../../../app/hooks'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useDownloadBatchCsvLazyQuery } from '../../../../api-services/payments/paymentsApi'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import { type BatchIdActionProps } from './DisbursementBatchPage'
import IconButton from '@mui/material/IconButton'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'

const DownloadBatchCsv: React.FC<BatchIdActionProps> = ({ disbursementBatch }: BatchIdActionProps) => {
  const dispatch = useAppDispatch()
  const [csvData, setCsvData] = useState<string>('')

  const [apiDownloadCsvTrigger] = useDownloadBatchCsvLazyQuery()
  const handleDownloadCsv = async (): Promise<void> => {
    apiDownloadCsvTrigger(disbursementBatch.disbursementBatchId)
      .unwrap()
      .then((triggerResult) => {
        setCsvData(triggerResult)
      })
      .catch((err) => {
        console.log(err)
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  return (
    <>
      { (csvData !== '') && (
        <IconButton color={'primary'} disabled={!disbursementBatch.downloadable}>
          <a
            href={`data:text/csv;charset=utf-8,${csvData}`}
            download={`${disbursementBatch.downloadFilename}`} style={{ border: 'None', width: '24px', height: '24px' }}>
            <FileDownloadIcon />
          </a>
        </IconButton>
      )}

      { (csvData === '') && (
        <IconButton color={'primary'} disabled={!disbursementBatch.downloadable} onClick={handleDownloadCsv}>
          <DownloadOutlinedIcon />
        </IconButton>
      )}
    </>
  )
}

export default DownloadBatchCsv
